import React from "react";

export type CRAClassificationValue =
  | "Not Applicable"
  | "Default"
  | "Important Class I"
  | "Important Class II"
  | "Critical"
  | null;

export interface CRAClassificationOption {
  label: string;
  value: string;
}

export const CRA_CLASSIFICATION_DESCRIPTION = {
  craClassification: (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div>
        <b>Not Applicable:</b> Select if your product lacks digital elements or
        is already regulated by specific laws (e.g., Medical Devices, Civil
        Aviation, or Motor Vehicles).
      </div>
      <div>
        <b>Default:</b> Most consumer-grade products: smart fridges, connected
        toys, basic apps, and non-critical software.
      </div>
      <div>
        <b>Important Class I:</b> Products that manage data or access: Password
        managers, VPNs, web browsers, and smart home security (locks/cameras).
      </div>
      <div>
        <b>Important Class II:</b> Core software and hardware: Operating systems
        (iOS/Android/Windows), industrial firewalls, and hypervisors
        (Docker/VMware).
      </div>
      <div>
        <b>Critical:</b> Highly sensitive hardware: Hardware Security Modules
        (HSMs), smartcard readers, and smart meter gateways.
      </div>
    </div>
  ),
};

export const CRA_CLASSIFICATION_OPTIONS: CRAClassificationOption[] = [
  {
    label: "Not Applicable",
    value: "Not Applicable",
  },
  {
    label: "Default",
    value: "Default",
  },
  {
    label: "Important Class I",
    value: "Important Class I",
  },
  {
    label: "Important Class II",
    value: "Important Class II",
  },
  {
    label: "Critical",
    value: "Critical",
  },
];

export const TOOLTIP_OVERLAY_STYLE = {
  maxWidth: 400,
  maxHeight: 300,
  overflowY: "auto" as const,
};
